module.exports = "/images/LTRL banner desktop v2.0.jpg?9e613e917b9370edbae583668d663dcf";